import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NodeAPI from "../api";
import axios from 'axios';
import {
  Container,
  Typography,
  Paper,
  Box,
 Button,
  CircularProgress,
  Avatar
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import QuizNotificationSettings from "./QuizNotificationSettings";
import DeleteIcon from '@mui/icons-material/Delete';

const UserProfile = () => {
  const navigate = useNavigate();
  const { user,logout } = useAuth();



const handleDelete = async () => {
  if (window.confirm("Are you sure you want to delete your account? This cannot be undone.")) {
    try {
      await NodeAPI.delete(`/quiz/users/${user.id}`);
      localStorage.removeItem('token'); // clear token
      logout(); // optional: call your logout method
      navigate('/'); // redirect to home or login
    } catch (err) {
      console.error("Account deletion failed:", err);
    }
  }
};

  if (!user) {
    return (
      <Box display="flex" justifyContent="center" mt={5}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Button component={Link} to="/categories" sx={{ mb: 2 }}>
        Back to Categories
      </Button>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box display="flex" alignItems="center" flexDirection="column" mb={3}>
          <Avatar sx={{ bgcolor: 'primary.main', width: 80, height: 80 }}>
            <AccountCircleIcon sx={{ fontSize: 50 }} />
          </Avatar>
          <Typography variant="h5" mt={2}>{user.username}</Typography>
          <Typography color="text.secondary">{user.email}</Typography>
        </Box>

       
<Box display="flex" flexDirection="column" alignItems="center" gap={2}>
<Typography variant="subtitle1">
  <strong>Status:</strong> {user.isVerified ? '✅ Verified' : '❌ Not Verified'}
</Typography>




  <Button variant="outlined" onClick={logout}>
    Logout
  </Button>

  <Button variant="outlined" color="error" startIcon={<DeleteIcon />} onClick={handleDelete}>
    Delete My Account
  </Button>

 
</Box>



        <QuizNotificationSettings />
      </Paper>
    </Container>
  );
};

export default UserProfile;
